export default "__VITE_ASSET__sV$VKHbo__"